import { render, staticRenderFns } from "./CurrencySimulation.vue?vue&type=template&id=7d3af256&scoped=true&"
import script from "./CurrencySimulation.vue?vue&type=script&lang=ts&"
export * from "./CurrencySimulation.vue?vue&type=script&lang=ts&"
import style0 from "./CurrencySimulation.vue?vue&type=style&index=0&id=7d3af256&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d3af256",
  null
  
)

export default component.exports